import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=ad84f3a8&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=ad84f3a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad84f3a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad84f3a8')) {
      api.createRecord('ad84f3a8', component.options)
    } else {
      api.reload('ad84f3a8', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=ad84f3a8&scoped=true", function () {
      api.rerender('ad84f3a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageHeader.vue"
export default component.exports